/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountEsistente } from './account-esistente';
import { SegnalazioneInCorso } from './segnalazione-in-corso';


export interface CollegamentoStatoDTO { 
    stato?: CollegamentoStatoDTOStatoEnum;
    provider?: CollegamentoStatoDTOProviderEnum;
    account?: AccountEsistente;
    segnalazione?: SegnalazioneInCorso;
}
export enum CollegamentoStatoDTOStatoEnum {
    NON_RICHIESTO = 'NON_RICHIESTO',
    RICHIESTO = 'RICHIESTO',
    SEGNALAZIONE_IN_CORSO = 'SEGNALAZIONE_IN_CORSO',
    NON_DISPONIBILE = 'NON_DISPONIBILE'
};
export enum CollegamentoStatoDTOProviderEnum {
    SPID = 'SPID',
    CIE = 'CIE'
};



